import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { string, bool, node } from 'prop-types'
import Loadable from '@loadable/component'

export const Field = Loadable(() => import(/* webpackChunkName: 'rff' */ 'react-final-form').then(({ Field }) => Field))

// Styled components
export const FieldComponent = styled.input`
	border-color: ${({ meta, theme = {} }) =>
		((meta.error && meta.touched) || meta.submitError) && !meta.dirtySinceLastSubmit && !meta.active
			? theme.colors.red
			: theme.colors.blue};
	width: ${({ width }) => width};
	height: ${({ height }) => height};
	border-style: solid;
	border-width: 1px;
	box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
	border-radius: 4px;
	display: block;
	width: calc(100% - 1em);
	padding: 8px;
	margin: 8px 0 0 0;
	font-size: 100%;
	color: ${({ theme }) => theme.colors.darkGrey};
	&:focus {
		outline: 1px solid ${({ theme }) => theme.colors.outlineBlue};
		-moz-outline-radius: 4px;
	}
	&::placeholder {
		color: ${({ theme }) => theme.colors.gray[300]};
	}
	${({ as }) =>
		as === 'select' &&
		css`
			height: 35px;
			width: 100%;
			background-color: #fff;
		`}
`

FormField.propTypes = {
	children: node,
	component: string,
	name: string.isRequired,
	type: string.isRequired,
	placeholder: string,
	required: bool,
}

/**
 * This is an input form field component with error styling for final form
 */
export function FormField(props) {
	const { component = 'input', children, ...restProps } = props
	return (
		<Field {...restProps}>
			{({ input, meta, ...props }) => {
				return <FieldComponent as={component} meta={meta} {...input} {...props} children={children} />
			}}
		</Field>
	)
}
